// extracted by mini-css-extract-plugin
module.exports = {"container":"_ad5c143","fullGame":"_f6700ac"};